import FrontImage from "../../assets/Pillars/main_image.jpg";

export default function HeroSection() {
  return (
    <section className="relative w-full bg-gradient-to-b from-black/50 to-black/20 overflow-hidden py-24">
      {/* Background accent shapes */}
      <div className="absolute -top-32 -left-24 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse-slow"></div>
      <div className="absolute -bottom-32 -right-24 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl animate-pulse-slow"></div>

      <div className="relative max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center gap-12 px-6 md:px-12">
        
        {/* Text Column */}
        <div className="md:w-2/3 text-center md:text-left space-y-6">
          <h1 className="text-white text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight drop-shadow-lg">
            The <span className="text-neonTurquoise">Kalon 4-Pillar</span> Performance System
          </h1>

          <p className="text-neonTurquoise text-lg sm:text-xl md:text-2xl font-semibold drop-shadow-md">
            Build strength, endurance, sport performance, and nutrition mastery
          </p>

          <p className="text-gray-300 text-base sm:text-lg md:text-lg max-w-xl drop-shadow-sm">
            Our system integrates science-backed training methods with lifestyle strategies to unlock peak performance. Ideal for athletes, professionals, and high performers ready to elevate their potential.
          </p>
        </div>

        {/* Image Column */}
        <div className="md:w-1/2 relative flex justify-center md:justify-end">
          {/* Floating layered cards */}
          <div className="relative w-full">
            <div className="absolute -top-6 -left-6 w-full h-full rounded-3xl border-2 border-cyan-500/20 transform rotate-2 shadow-lg"></div>
            <div className="absolute -bottom-6 -right-6 w-full h-full rounded-3xl border-2 border-purple-500/20 transform -rotate-2 shadow-lg"></div>

            <div className="relative overflow-hidden rounded-3xl shadow-2xl">
              <img
                src={FrontImage}
                alt="Kalon Pillars"
                className="w-full h-[32rem] md:h-[36rem] object-cover transform transition-transform duration-500 hover:scale-105"
              />
              {/* Gradient overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>

            {/* Floating accent circles */}
            <div className="absolute -top-10 -left-10 w-24 h-24 border-4 border-cyan-400 rounded-full opacity-40 animate-pulse-slow"></div>
            <div className="absolute -bottom-8 -right-12 w-32 h-32 border-4 border-purple-400 rounded-full opacity-30 animate-pulse-slow"></div>
          </div>
        </div>
      </div>

      {/* Optional bottom curved divider for transition to next section */}
      <div className="absolute bottom-0 w-full h-20 md:h-32 bg-gradient-to-t from-black/20 to-transparent rounded-t-full"></div>
    </section>
  );
}
